import { render, staticRenderFns } from "./OnboardingTabStart.vue?vue&type=template&id=0a58483a"
import script from "./OnboardingTabStart.vue?vue&type=script&lang=ts"
export * from "./OnboardingTabStart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports